import { Box, SxProps, Theme, Typography, useTheme } from '@mui/material'

import responsiveHook from '@hooks/useResponsive'

import { listStyle } from './styles'
import './styles.css'

interface IBulletPointsProps {
  list: string[]
  containerSx?: SxProps<Theme>
}

const BulletPoints = ({ list, containerSx }: IBulletPointsProps) => {
  const theme = useTheme()
  const { ifDesktop } = responsiveHook.useResponsive()

  return (
    <Box sx={containerSx}>
      <ul style={listStyle({ theme })}>
        {list.map((v) => (
          <li key={v} className={ifDesktop('liStyle') ?? ''}>
            <Typography>{v}</Typography>
          </li>
        ))}
      </ul>
    </Box>
  )
}

export { BulletPoints }
